<template>
  <div class="page-content page-sing-in">
    <div class="sing-in-content">
      <div class="sing-in-box">
        <div class="row">
          <div class="col-md-6">
            <div class="info">
              <h1>{{globalParameters.slogan}}</h1>
              <h2 v-html="globalParameters.subTitle" />
              <span v-html="globalParameters.description" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="info-box">
              <div class="logo"><a href="#"><img class="logo" src="../../../public/img/logo.png" alt=""></a></div>
              <div class="form-sing-in">
                <h2>{{L10n('sign-in')}}</h2>
                <div class="steps">
                  <transition name="fade" mode="out-in">
                    <component
                      :is="`step-${currentStep}`"
                      :email.sync="email"
                      @step="handleChangeStep"/>
                  </transition>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer-sign-in">
      <div class="footer-sign-in-box">
        <div class="row">
          <div class="col-md-6">
            <span class="copyright">{{globalParameters.copyrights}}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LoginIndex',
  components: {
    'step-code': () => import(/* webpackChunkName: 'Login' */ './StepCode'),
    'step-email': () => import(/* webpackChunkName: 'Login' */ './StepEmail')
  },
  data () {
    return {
      currentStep: 'email',
      email: ''
    }
  },
  computed: {
    globalParameters () {
      return this.$store.getters.get('globalParameters')
    }
  },
  methods: {
    handleChangeStep (Step) {
      this.currentStep = Step
    }
  }
}
</script>

<style lang="stylus">
  /*:TODO Main*/
  .page-sing-in {
    background #fff
    display flex
    flex-direction column
    padding 0 1.5rem
    &:before {
      display block
      content ''
      position absolute
      bottom 0
      left 0
      top 0
      width 50%
      background #06aaea
      z-index -1
      pointer-events none
    }
    &:after {
      display block
      content ''
      height 35.3rem
      width 933px
      background url('../../../public/img/bg_singin.png') no-repeat
      position absolute
      top 0
      left 50%
      margin 0 0 0 -65.5rem
      z-index -1
    }

    .sing-in-content {
      flex 1 0 auto
      display flex
      align-items center
    }

    .sing-in-soclias {
      list-style none
      margin: 0 0 0 -2.5rem
      letter-spacing -0.36em
      > li {
        display inline-block
        letter-spacing normal
        vertical-align middle
        padding 0 0 0 2.5rem
        > a {
          opacity 0.5
          transition opacity .15s ease-in-out
          &:hover {
            opacity 1
          }
        }
      }
    }

    .sing-in-box {
      max-width 1070px
      width 100%
      margin 0 auto
      > .row {
        margin 0 -30px
        > div {
          padding 0 30px
        }
      }
    }

    .info {
      max-width 400px
      margin 0
      color #fff
      font-size 1.6rem
      line-height 1.6
      padding 1.3rem 0 0
      h1 {
        font-size 4.4rem
        font-weight 900
        line-height 1
        text-transform uppercase
        margin 0 0 3rem
        color #fff
      }
      h2 {
        font-size: 1.8rem
        font-weight bold
        color #Fff
        line-height 1.45
        margin 0 0 1rem
      }

      p {
        margin 0 0 3.2rem
      }
    }

    .info-box {
      max-width 366px
      margin-left auto
      .logo {
        margin 0 0 5.7rem
      }
    }
    .form-sing-in {
      h2 {
        margin 0 0 3.6rem
        font-size 2rem
        color #65646c
        font-weight bold
        text-transform uppercase
      }
      p {
        font-size 1.2rem
        color #65646c
        margin -1.5rem 0 0
      }
      label {
        font-size 1.2rem
        color #65646c
      }
      .btn-back {
        background none
        box-shadow none
        color #09729b
        padding-left 0
        padding-right 0
        font-size 1.4rem
        text-transform uppercase
      }

      /* form element*/
      .el-form-item.material-style .el-form-item__label {
        font-size 1.4rem
        color #64636a
      }
      .el-form-item.material-style[data-focus] .el-form-item__label
      .el-form-item.material-style[data-filed] .el-form-item__label {
        font-size: 1.1rem
      }
      .el-form-item.material-style.is-error .el-form-item__label {
        color #9b0909
      }
      .el-form-item.material-style .el-form-item__content .el-input:after
      .el-form-item.material-style .el-form-item__content .el-textarea:after {
        background #06aaea
      }
      .el-form-item.material-style.is-error .el-form-item__content .el-input:after
      .el-form-item.material-style.net-error .el-form-item__content .el-input:after {
        background #9b0909
      }
      .el-form-item.material-style .el-form-item__content .el-form-item__error {
        font-size 1.1rem
        font-weight normal
        color #9b0909
      }
      /* end form element*/

      .form-sing-up-step-code .keys-wrapper .el-form-item__content {
        max-width 23.6rem
        margin 0
      }
      .el-form-item.material-style .el-form-item__error {
        position absolute
        top 100%
        left 0
        right 0

      }
      .form-sing-up-step-code .net-error-message {
        margin 1rem 12rem 0 0
      }
      .btn-sing-in {
        display inline-block
        height 4.2rem
        width 14.2rem
        background #06aaea
        font-size 1.6rem
        font-weight bold
        text-transform uppercase
        color #fff
        border-radius 3px
        border 0
        box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.2)
      }
      .form-footer {
        .buttons {
          display flex
          justify-content: space-between
        }
        p {
          font-size 1.5rem
          font-weight 400
          color #36587a
          white-space nowrap
        }
      }
      .form-more {
        border-top 1px solid #eef2f4
        margin 54px 0 0
        padding 52px 0 0
        display flex
        align-items center
        justify-content space-between
      }
    }

    /*:TODO footer*/
    .footer-sign-in {
      padding 2.5rem 0
      flex 0 0 auto
      .footer-sign-in-box {
        max-width 1070px
        margin 0 auto
        > .row {
          margin -10px -30px 0
          > div {
            padding 10px 30px 0
          }
        }
      }
      .footer-sign-in-nav {
        display flex
        flex-wrap wrap
        list-style none
        margin 0
        > li {
          position relative
          font-size 1.2rem
          padding 0 8px 0 0
          margin 0 7px 0 0
          &::before {
            display block
            content '|'
            color #65646c
            position absolute
            top 0
            right 0
          }
          &:last-child {
            margin-right: 0
            padding-top: 0
            &::before {
              display none
            }
          }
          > a {
            color #06aaea
          }
        }

      }
      .copyright {
        display block
        text-align right
        color rgba(255, 255, 255, 0.5)
        font-size 1.2rem
        text-align right
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .page-sing-in {
      &::before {
        display none
      }
      &::after {
        display none
      }
      .sing-in-content {
        align-items flex-start
      }
      .info {
        margin 0 -15px
        padding 3rem 15px
        background #06aaea
        max-width inherit
        min-height inherit
        text-align center
        font-size: 1.4rem
        h1 {
          font-size 3.4rem
        }
      }
      .info-box {
        margin 0 auto
        padding 3rem 0
        .logo {
          margin-bottom: 2rem
        }
      }
      .footer-sign-in {
        background #06aaea
        margin 0 -15px
        padding 15px
        text-align center
        .copyright {
          text-align center
          color #fff
        }
        .footer-sign-in-nav {
          justify-content center
          > li {
            &::before {
              color #fff
            }
            > a {
              color #fff
            }
          }
        }
      }
    }
  }

</style>
